import { render, staticRenderFns } from "./SwitchApp.vue?vue&type=template&id=33345d51&"
import script from "./SwitchApp.vue?vue&type=script&lang=js&"
export * from "./SwitchApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports